// Page breaks for a four-section template, worked out by the band layout
// engine and returned in the shape the preview draws: per page, which
// sections show and which item rows it holds.

import { sectionsToBands } from "./bandModel";
import { paginateBands } from "./bandLayout";

//   template     { heights, head, total, foot } as stored
//   pageHeight   page height, px
//   rowCount     number of item rows
//   rowPitch     px per item row, including its line
//   tableChrome  px the items table needs on every page it appears on
//   topMarginPx  space above the table on a page without the header
export function getSectionPages({ template, pageHeight, rowCount, rowPitch, tableChrome, topMarginPx }) {
  const bands = sectionsToBands(template, { pageHeightPx: pageHeight });
  const bandHeights = Object.fromEntries(bands.map((band) => [band.id, band.height]));
  const { head: headPx, total: totalPx, foot: footPx } = bandHeights;

  const { pages } = paginateBands({
    bands,
    pageHeight,
    bandHeights,
    rowHeights: Array.from({ length: Math.max(0, rowCount) }, () => rowPitch),
    tableChrome,
    emptyTopInset: topMarginPx,
  });

  return {
    pages: pages.map((page) => {
      const block = (id) => page.blocks.find((b) => b.bandId === id);
      const items = block("items");
      return {
        showHeader: !!block("head"),
        topSpacer: block("head") ? 0 : topMarginPx,
        hasTable: !!items,
        firstRowIndex: items ? items.firstRow : 0,
        rowCount: items ? items.rowCount : 0,
        showTotal: !!block("total"),
        showFooter: !!block("foot"),
      };
    }),
    headPx,
    totalPx,
    footPx,
    totalAboveFooter: template.total?.position === "aboveFooter",
  };
}
